import axiosSmartSurvey from '../../../api/axios'
import useAuth from '../../../hooks/useAuth'

export default function useTrackDoc() {
    const { user } = useAuth()

    async function fetchAndAppendFolderData(parcelCode, docData, setDocData, setOpenError, setErrorText) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/folderdata',
                data: { parcelCode }
            });
            addTransection(parcelCode, "fetchAndAppendFolderData", `ดึงข้อมูลซอง ${user.fName + " " + user.lName}`)
            const folderData = response.data.folderData;
            setDocData([
                ...docData,
                {
                    id: folderData.id,
                    parcelCode: folderData.parcelCode,
                    dn: folderData.dn,
                    oldParcel: folderData.oldParcel,
                    holder: folderData.holder,
                    recievedDate: folderData.recievedDate,
                    fname: folderData.fname,
                    lname: folderData.lname
                }
            ]);
        } catch (err) {
            setOpenError(true)
            setErrorText(err.response.data.message)
            // console.error('Error fetching folder data:', err);
        }
    }
    async function fetchSingleFolderData(parcelCode, setDoc, setOpenError, setErrorText) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/folderdata',
                data: { parcelCode }
            });
            addTransection(parcelCode, "fetchSingleFolderData", `ค้นหาข้อมูลซองโดย ${user.fName + " " + user.lName}`)
            const folderData = response.data.folderData;
            setDoc({
                id: folderData.id,
                parcelCode: folderData.parcelCode,
                dn: folderData.dn,
                oldParcel: folderData.oldParcel,
                holder: folderData.holder,
                recievedDate: folderData.recievedDate,
                fname: folderData.fname,
                lname: folderData.lname,
                parcelType: folderData.parcelType,
                gid: folderData.gid,
            });
        } catch (err) {
            setOpenError(true)
            setErrorText(err.response.data.message)
            // console.error('Error fetching folder data:', err);
        }
    }
    // 🟢 เพิ่ม customHolderId และ customHolderName เข้ามาในพารามิเตอร์
    async function updateCurrentHolder(
        docData,
        setOpenSuccess,
        setOpenError,
        setSuccessText,
        setErrorText,
        customHolderId = null,    // 👈 ถ้ารับเอกสารปกติจะเป็น null
        customHolderName = null   // 👈 ถ้ารับเอกสารปกติจะเป็น null
    ) {
        if (!docData || docData.length === 0) {
            setOpenError(true);
            setErrorText('ไม่มีรายการเอกสารในตาราง');
            return;
        }

        // 🟢 ถ้ามีการส่ง customHolderId มา (เช่น -1 หรือ 99) ให้ใช้ค่านั้น ถ้าไม่มีให้ใช้ user.userId เดิม
        const targetUserId = customHolderId !== null ? customHolderId : user.userId;
        const targetUserName = customHolderName !== null ? customHolderName : `${user.fName || ''} ${user.lName || ''}`.trim();

        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/updatecurrentholder',
                data: {
                    docData: docData,
                    userId: targetUserId // ส่ง targetUserId ไปให้เซิร์ฟเวอร์
                }
            });

            if (response.status === 200) {
                // 🟢 บันทึก Transaction ประวัติการเปลี่ยนผู้ถือครอง
                docData.forEach(data => {
                    addTransection(
                        data.parcelCode,
                        "holder_update",
                        `เปลี่ยนผู้ถือครองเป็น ${targetUserName}`
                    );
                });

                setOpenSuccess(true);
                setSuccessText(customHolderId !== null ? 'เสนอผู้บริหารสำเร็จ' : 'รับซองสำเร็จ');
            }
        } catch (err) {
            console.error("updateCurrentHolder Error:", err);
            setOpenError(true);
            setErrorText(customHolderId !== null ? 'เสนอผู้บริหารไม่สำเร็จ' : 'รับซองไม่สำเร็จ');
        }
    }
    async function returnDoc(docData, setOpenSuccess, setOpenError, setSuccessText, setErrorText) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/updatecurrentholder',
                data: {
                    docData: docData,
                    userId: 0
                }
            });
            await docData.forEach(data => {
                addTransection(data.parcelCode, "returnDoc", `เก็บเข้าแฟ้มโดย${user.fName + " " + user.lName}`)
            });
            const status = response.status
            if (status === 200) {
                setOpenSuccess(true)
                setSuccessText('เก็บเข้าแฟ้มสำเร็จ')
            }
        } catch (err) {
            setOpenError(true)
            setErrorText('เก็บเข้าแฟ้มไม่สำเร็จ')
            console.error('เกิดข้อผิดพลาดในการอัปเดตผู้ถือครอง:', err);
        }
    }
    async function addFolder(modalForm, setOpenSuccess, setOpenError, setSuccessText, setErrorText) {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/trackdoc/addfolder',
                data: {
                    modalForm: modalForm,
                    userId: user.userId
                }
            });
            console.log(response)
            const { parcelCode } = modalForm
            addTransection(parcelCode, 'addFolder', `เพิ่มซองโดย${user.fName + " " + user.lName}`)
            const status = response.status
            if (status === 200) {
                setOpenSuccess(true)
                setSuccessText('เพิ่มซองสำเร็จ')
            }
        } catch (err) {
            console.log(err)
            setOpenError(true)
            setErrorText(err.response.data.message)
        }
    }

    async function addTransection(parcelCode, actionType, description) {
        console.log(parcelCode, actionType, description)
        try {
            const response = await axiosSmartSurvey.post('/trackdoc/logtransaction', {
                parcelCode: parcelCode,
                actionType: actionType,
                description: description,
                userId: user.userId
            });
            console.log('เก็บทรานเซ็คชั่นสำเร็จ:', response.data);
        } catch (err) {
            console.error('เกิดข้อผิดพลาดเก็บทรานเซ็คชั่น', err);
        }
    }


    return { fetchAndAppendFolderData, fetchSingleFolderData, updateCurrentHolder, returnDoc, addFolder }
}
